import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import DashboardComponent from '../dashboardComponent';
import {getEndComponent, getOpenComponent} from '../../../../app/store/reducers/menu';
import {useNavigate} from 'react-router-dom';
import {getDashboardAccount} from '../../../../app/store/reducers/dashboard';

const SettingsHeader = () => {
    const navigate = useNavigate();

    const endComp = useSelector(getEndComponent);
    const openComponent = useSelector(getOpenComponent);
    const dashboardAccount = useSelector(getDashboardAccount);

    const dashboardObj = useMemo(() => {
        if (openComponent && openComponent !== 'settings') {
            return {
                sfid: openComponent?.toLowerCase() || null,
                name: openComponent?.charAt(0).toUpperCase() + openComponent?.slice(1) || null
            };
        } else {
            return {sfid: null, name: null};
        }
    }, [openComponent]);

    const settingsDashboard = {sfid: 'settings', name: 'Settings'};

    const handelSettingsClick = () => {
        navigate(`/account/${dashboardAccount.sfid}/settings`);
    };

    return (
        <>
            <DashboardComponent
                type={settingsDashboard.name}
                dashboardObj={settingsDashboard}
                isLoading={false}
                isSuccess={true}
                data={[]}
                createHandleMenuClick={() => {}}
                isActive={endComp == settingsDashboard.sfid}
                onClick={handelSettingsClick}
            />
            {dashboardObj.sfid && (
                <DashboardComponent
                    type={dashboardObj.name}
                    dashboardObj={dashboardObj}
                    isLoading={false}
                    isSuccess={true}
                    data={[]}
                    createHandleMenuClick={() => {}}
                    isActive={endComp == dashboardObj.sfid}
                />
            )}
        </>
    );
};

export default SettingsHeader;
